export function LoadingScreen() {
  return (
    <div className="loading-screen">
      <h1 className="loading-title">HOLLOWVEIL</h1>
      <div className="loading-spinner" />
    </div>
  );
}
